import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { PaisResponse } from '@/core/api/sicom-api/registro/medico/pais/pais.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PaisService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.paises;

    listarPaises(context?: HttpContext): Observable<PaisResponse[]> {
        return this.http.get<PaisResponse[]>(this.PATH, { context });
    }
}
